import { ChevronLeft } from "lucide-react";

import ButtonWithIcon from "@/components/ui/ButtonWithIcon";

type IbackBtn = {
  backBtn?: () => void;
};

const BackButton: React.FC<IbackBtn> = ({ backBtn }): React.JSX.Element => {
  return (
    <ButtonWithIcon
      variant={"outline"}
      size={"icon"}
      onClick={backBtn ? backBtn : (): void => window.history.back()}
      icon={<ChevronLeft size={24} className='text-primary' strokeWidth={2} />}
    />
  );
};

export default BackButton;
